/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityOrganizationPrevalence {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityOrganizationPrevalence.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityOrganizationPrevalence>): AppSecopsVulnerabilityOrganizationPrevalence {
        let obj = Object.assign(new AppSecopsVulnerabilityOrganizationPrevalence(), model);
        AppSecopsVulnerabilityOrganizationPrevalence.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityOrganizationPrevalence>): AppSecopsVulnerabilityOrganizationPrevalence {
        if (!model) return null;
        return AppSecopsVulnerabilityOrganizationPrevalence.newInstance(<AppSecopsVulnerabilityOrganizationPrevalence> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityOrganizationPrevalence) {
        if (!obj) return;

        models.AppSecopsVulnerabilityOrganizationPrevalence.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityOrganizationPrevalence): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityOrganizationPrevalence.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique ID of the vulnerability
     */
    vulnerability_id: string;

    /**
     * Application ID
     */
    application_id: string;

    /**
     * Appsecops project ID
     */
    appsecops_project_id: string;

    /**
     * Portfolio ID
     */
    portfolio_id: string;

}
